<dx-popup [title]="popupTitle" width="80vw" height="80vh" [(visible)]="popupVisible" (onHiding)="closedPopup()"
  [hideOnOutsideClick]="false" [showCloseButton]="true">

  <p>
    Righe caricate: {{importResult?.righeCaricate}}<br />
    Righe importate: {{importResult?.righeImportate}}
  </p>


  @if (listErrori && listErrori.length > 0) {
    <dx-data-grid #gridMessaggiErrore id="gridContainer"
      [dataSource]="listErrori" [showBorders]="true" [height]="510">
      <dxo-paging [pageSize]="15"> </dxo-paging>
      <dxo-export [enabled]="true"></dxo-export>
    </dx-data-grid>
  }
</dx-popup>
@if(!listErrori || listErrori.length == 0){
  <p style="margin-left: 10px;">
    Non si sono verificati errori.
  </p>
}